module.exports = __webpack_public_path__ + "static/media/kelly.205247a0.jpeg";